export const validateDrivingLicense = (
  license: string
): { isValid: boolean; error?: string; formattedValue?: string } => {
  if (!license) return { isValid: true };

  let formattedLicense = '';
  let error = undefined;

  for (let i = 0; i < Math.min(license.length, 2); i++) {
    const char = license[i];
    if (!/[A-Za-z]/.test(char)) {
      return {
        isValid: false,
        error: 'First two characters must be alphabets',
        formattedValue: license.substring(0, i + 1)
      };
    }
    formattedLicense += char.toUpperCase();
  }

  for (let i = 2; i < Math.min(license.length, 4); i++) {
    const char = license[i];
    if (!/\d/.test(char)) {
      return {
        isValid: false,
        error: 'Characters 3-4 must be numbers',
        formattedValue: formattedLicense + license.substring(2, i + 1)
      };
    }
    formattedLicense += char;
  }

  if (license.length > 4) {
    formattedLicense += ' ';
  }

  const afterPrefix = license.substring(5).replace(/\s/g, '');
  formattedLicense += afterPrefix;

  if (afterPrefix.length > 0 && !/^\d*$/.test(afterPrefix)) {
    return {
      isValid: false,
      error: 'Only numbers allowed after space',
      formattedValue: formattedLicense
    };
  }

  if (afterPrefix.length > 12) {
    error = 'Only 12 digits allowed after space';
  }

  return {
    isValid: !error,
    error,
    formattedValue: formattedLicense
  };
};
